import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../store/reducers';
import { getChatList, setUserChat } from '../../../../../store/reducers/Chat/slice';
import styles from '../../ChatModal.module.scss';
import ChatLabel from '../../../../Chat/ChatLabel/ChatLabel';
import Heading from '../../../../Typography/Heading/Heading';
import cn from 'classnames';
import { displayName } from '../../../../LabelBox/LabelBox';
const ChatList = ({ onSwitchToChatView }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { chats } = useAppSelector((state) => state.chat);
    const { walletInfo } = useAppSelector((state) => state.wallet.activeWallet);
    const getName = useCallback((chat) => {
        if (chat.guild_name) {
            return chat.guild_name;
        }
        if (walletInfo) {
            const toUser = chat.users.find((user) => user.address !== walletInfo.stakeId);
            return toUser ? displayName(toUser.name, toUser.address) : '';
        }
        return '';
    }, [walletInfo]);
    const onChatClick = useCallback((item) => {
        dispatch(setUserChat(item));
        onSwitchToChatView();
    }, [dispatch, onSwitchToChatView]);
    useEffect(() => {
        dispatch(getChatList());
    }, [dispatch]);
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: cn(styles.header, 'd-flex align-items-center') }, { children: _jsx(Heading, { className: styles.title, size: 5, fontWeight: 500, title: t('Chats') }) })), _jsx("div", Object.assign({ className: 'd-flex flex-column' }, { children: chats
                    .filter(({ state }) => state.all)
                    .map((data) => (_jsx(ChatLabel, { type: data.type, isModal: true, name: getName(data), unreadCount: data.state.unread, date: data.last_message.date, message: data.last_message.message, onClick: () => onChatClick(data) }, data.id))) }))] }));
};
export default ChatList;
